import styled, { css } from 'styled-components';

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > svg {
    cursor: pointer;
    min-height: 14px;
    min-width: 14px;
    color: rgba(0, 0, 0, 0.54);
  }
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 25px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const Days = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

interface IPropsDay {
  selected?: boolean;
}

export const Day = styled.button<IPropsDay>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dadada;
  border-radius: 100%;
  height: 44px;
  width: 44px;
  background-color: transparent;
  outline: none !important;

  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.gray};

  ${({ selected, disabled }) => {
    if (selected) {
      return css`
        color: ${({ theme }) => theme.colors.blue};
        border-color: ${({ theme }) => theme.colors.blue};
        font-family: 'Mangueira Bold';
      `;
    }

    if (disabled) {
      return css`
        font-family: 'Mangueira Bold';
        background-color: #eeeeee;
        border-color: #eeeeee;
        cursor: default;
      `;
    }

    return null;
  }}

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 340px) {
    width: 33px;
    height: 33px;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 20px 0;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  /* @media (max-width: 768px) {
    flex-direction: column;
    align-items: ;
    justify-content: center;
  } */
`;

export const ItemTitle = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #757575;

  @media (max-width: 768px) {
    font-family: 'Mangueira Bold';
  }
`;

export const PrimaryPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SecondyPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  & > svg {
    min-height: 13px;
    min-width: 13px;
    color: ${({ theme }) => theme.colors.blue};
    cursor: pointer;
  }
`;

export const TextIntervals = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #757575;
`;

export const Intervals = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 22px;
  flex-direction: column;
`;

export const Interval = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SelectsContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > label {
    width: 45%;

    & svg {
      min-width: 15px;
      min-height: 15px;
    }
  }

  @media (max-width: 768px) {
    & > label {
      width: 50%;
    }
  }
`;

export const IntervalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 14px;
    line-height: 22px;
    font-family: 'Mangueira Bold';
    color: #757575;
  }
`;

interface ContentAddPlus {
  mobile?: boolean;
}

export const ContentAddPlus = styled.div<ContentAddPlus>`
  & svg {
    min-width: 36px;
    min-height: 36px;
    color: ${({ theme }) => theme.colors.blue};
    cursor: pointer;
  }

  display: ${({ mobile }) => (mobile ? 'none' : 'flex')};

  @media (max-width: 768px) {
    display: ${({ mobile }) => (mobile ? 'flex' : 'none')};

    & svg {
      min-height: 25px;
      min-width: 25px;
    }
  }
`;

export const ContentButton = styled.div`
  width: 91%;

  & > button {
    width: 100%;
    background-color: #2dfffe;
    color: #0b29fb;

    &:disabled {
      background-color: #eeeeee;
      color: #7a7a7a;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;

  & > button {
    min-width: 35%;
  }
`;
